import { styled } from "@mui/material";

export const EmailTitle = styled("div")(() => ({
  color: "#465869",
  fontSize: 14,
  lineHeight: "21px",
  fontWeight: 500,
  fontFamily: "Manrope",
}));
